export enum EItemPriority {
  highest = 1,
  high = 2,
  medium = 3,
  low = 4,
  lowest = 5,
}

export interface IItemPriorityStyle {
  color: string;
  icon: string;
}

export const itemPriorityStyle: Record<EItemPriority, IItemPriorityStyle> = {
  [EItemPriority.highest]: { color: '#c62828', icon: 'keyboard_double_arrow_up' },
  [EItemPriority.high]: { color: '#ef6c00', icon: 'keyboard_arrow_up' },
  [EItemPriority.medium]: { color: '#f9a825', icon: 'drag_handle' },
  [EItemPriority.low]: { color: '#2e7d32', icon: 'keyboard_arrow_down' },
  [EItemPriority.lowest]: { color: '#1565c0', icon: 'keyboard_double_arrow_down' },
};

export const itemPriorityOrder: EItemPriority[] = Object.keys(itemPriorityStyle).map(Number) as EItemPriority[];

export const getItemPriorityTranslationKey: (priority: EItemPriority | string) => string = (
  priority: EItemPriority | string,
): string => {
  const numericPriority = Number(priority);
  const label: string = Number.isNaN(numericPriority) ? `${priority}` : EItemPriority[numericPriority as EItemPriority];

  return `system.label.priority.${label}`;
};
